import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    padding: '28px 30px 30px 30px',
    background: '#F7F8FC',
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden'
  },
  separator:{
    height:'1px',
    background: theme.palette.grey.grey200,
    width: '943px',
    marginLeft: 'auto',
    marginRight:'auto'
  },
  navigationHidder:{
    position:'absolute',
    zIndex:1000,
    top: '61px',
    background: 'linear-gradient(113deg, rgba(255, 255, 255, 0.49) 0%, rgba(255, 255, 255, 0.48) 110.84%)',
    width: '100%',
    height: '71px',
    opacity: 0,
    transition: '0.2s linear opacity',
    '&.show': {
      backdropFilter: 'blur(10px)',
      opacity:1,
    }
  },
  container: {
    //background: "linear-gradient(113deg, rgba(255, 255, 255, 0.49) 0%, rgba(255, 255, 255, 0.48) 110.84%)",
    borderRadius:'4px',
    //border: '1.5px solid white',
    //padding:'0px 22px 30px 22px',
    minWidth: '981px',
    height: 'fit-content',
  },
}));

export default useStyles;
